<template>
  <div>
    <section class="pb-2">
      <b-card
        class="my-50"
        no-body
      >
        <div>
          <Table
            :data="allTargetingProperties"
            :columns="targetingColumns"
            :is-loading="isLoading"
            type-of-table="targeting"
            :enable-pagination="false"
            :enable-sort="false"
          />
        </div>
      </b-card>
    </section>
  </div>
</template>

<script>
import Table from '@/components/Table.vue'
import {
  computed,
  onMounted,
  ref,
} from '@vue/composition-api'
import store from '@/store'
import translation from '@/mixins/translate'

export default {
  components: {
    Table,
  },
  setup() {
    const targetingColumns = [
      {
        label: translation.methods.$tk('ClientPortal.Admin.Targeting.Name'),
        field: 'name',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Targeting.DisplayName'),
        field: 'displayName',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Targeting.BidIncrement'),
        field: 'bidIncrement',
      },
    ]
    const allTargetingProperties = computed(() => store.getters.allTargetingProperties)
    const isLoading = ref(false)

    onMounted(async () => {
      isLoading.value = true
      await store.dispatch('getTargetingProperties')
      isLoading.value = false
    })

    return {
      allTargetingProperties,
      isLoading,
      targetingColumns,
    }
  },
}
</script>
